import { render, staticRenderFns } from "./FDataTable.vue?vue&type=template&id=35848b75&"
import script from "./FDataTable.vue?vue&type=script&lang=js&"
export * from "./FDataTable.vue?vue&type=script&lang=js&"
import style0 from "./FDataTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports